var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.medicalReport)?_c('agent-picker',{attrs:{"groupName":_vm.groupNames.MEDICAL_REPORT_ASSIGNEES,"agent":_vm.agent,"hintLabel":_vm.$t('inbox.room.medicalReport.agentPicker.hint'),"small":true},on:{"select-agent":_vm.assignAgent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }